import React, { act, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "./Navbar.module.css";
import { ReactComponent as Gna } from "../../assets/images/logo.svg.svg";

import { useDispatch, useSelector } from "react-redux";
import { publicEnergyType, publicRating } from "../../Redux/Slices/publicSlice";
// import { userAccess } from "../../Redux/Slices/profileSlice";

import NavProfile from "./NavProfile";
import NavbarProfile from "./NavbarProfile";
import MenuIcon from "@mui/icons-material/Menu";
import MobileNavbar from "./MobileNavbar";
import { userAccess } from "../../Redux/Slices/profileSlice";
import NotificationContainer from "./NotificationContainer/NotificationContainer";

const navList = {
  CONSUMER: [
    {
      name: "Home",
      url: "dashboard",
    },
    {
      name: "Bilateral Ledger",
      url: "bilateral",
    },
    {
      name: "Auction",
      url: "auction",
    },
    {
      name: "Search Listing",
      url: "search_listing",
    },
    {
      name: "Landing Cost Calculator",
      url: "lcc",
    },
    {
      name: "Past Listing",
      url: "past_listing_con_gen",
    },
  ],
  GENERATOR: [
    {
      name: "Home",
      url: "dashboard",
    },
    {
      name: "Ledger",
      url: "bilateral",
    },
    {
      name: "Auction",
      url: "auction",
    },
    {
      name: "Search Listing",
      url: "search_listing",
    },
    {
      name: "Landing Cost Calculator",
      url: "lcc",
    },
    {
      name: "Past Listing",
      url: "past_listing_con_gen",
    },
  ],
  COMPANY_ADMIN: [],
};

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state?.persistedReducer?.token);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  );
  const activeEntity = useSelector(
    (state) => state?.activeEntity?.activeEntity
  );
  const activeSidebarItem = useSelector(
    (state) => state?.activeEntity?.activeSidebarItem
  );
  const profile = useSelector((state) => state?.profileSlice);

  const [drawer, setDrawer] = useState(false);

  useEffect(() => {
    if (token && !profile.userAccess) {
      dispatch(userAccess(token));
    }
    dispatch(publicRating());
    dispatch(publicEnergyType());
  }, [token, profile.userAccess, dispatch]);

  const handleRoute = (url) => {
    navigate(`/${url}`);
  };

  const isActiveRoute = (url) => {
    return location.pathname === `/${url}`;
  };

  function Styling(activeEntity, role, activeSidebarItem) {
    return (
      <div>
        <div style={{ color: "#6F6D7C", fontWeight: "600" }}>
          {activeEntity}
        </div>
        <div
          style={{
            marginTop: "2px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
            color: role === "GENERATOR" ? "#34656D" : "#f1935c",
            fontWeight: "500",
          }}
        >
          <span>{activeSidebarItem}</span>

          {role && (
            <>
              <span>-</span>
              <span>{role === "GENERATOR" ? "Sell" : "Buy"}</span>
            </>
          )}
        </div>
      </div>
    );
  }

  const getDashboardTitle = () => {
    const currentPath = location.pathname;
    if (currentPath.includes("/my_profile")) {
      return `My Profile`;
    } else if (currentPath.includes("/wallet")) {
      return `Escrow`;
    } else if (currentPath.includes("/archive")) {
      return `${activeEntity} - Archive`;
    } else if (currentPath.includes("/unified_ledger")) {
      return `${activeEntity} - Unified Ledger`;
    } else if (currentPath.includes("/coming-soon")) {
      return `OTC Dashboard - Coming Soon`;
    } else {
      switch (role) {
        case "BANKING":
          return Styling(activeEntity, "", "Banking");
        case "CONSUMER":
          return Styling(activeEntity, role, activeSidebarItem);
        case "GENERATOR":
          return Styling(activeEntity, role, activeSidebarItem);
        default:
          break;
      }
    }

    return "OTC Dashboard";
  };
  // const getDashboardTitle = () => {
  //   const currentPath = location.pathname;

  //   if (
  //     currentPath.includes("/ledger") ||
  //     currentPath.includes("banking_active") ||
  //     currentPath.includes("banking_ledger")
  //   ) {
  //     return "LEDGER";
  //   }

  //   if (currentPath.includes("/banking_search")) {
  //     return "Available Banking";
  //   }

  //   if (currentPath.includes("/my_profile")) {
  //     return "My Profile";
  //   }

  //   if (currentPath.includes("/wallet")) {
  //     return "Wallet";
  //   }

  //   if (currentPath.includes("/archive")) {
  //     return "Archive Listings";
  //   }
  //   if (currentPath.includes("/unified_ledger")) {
  //     return "Unified Ledger";
  //   }
  //   if (currentPath.includes("/lcc")) {
  //     return "Landing Cost Calculator";
  //   }
  //   if (currentPath.includes("/reverse_auction")) {
  //     return "Reverse Auction";
  //   }
  //   if (currentPath.includes("/search_listing")) {
  //     return "Search Listing";
  //   }
  //   if (currentPath.includes("/rfq")) {
  //     return "Request for Proposal";
  //   }

  //   if (currentPath === "/banking" || currentPath === "/dashboard") {
  //     return "OTC Dashboard";
  //   }

  //   return "OTC Dashboard";
  // };

  const handleClose = () => {
    setDrawer(false);
  };

  return (
    <>
      {drawer && <MobileNavbar open={drawer} handleClose={handleClose} />}
      <div className={Styles.navbar_section}>
        <div className={Styles.navbar_sub_container}>
          <div className={Styles.navbar_logo_section}>
            <div className={Styles.navabr_logo}>
              <Gna />
            </div>
            <div className={Styles.dashboardTitle}>{getDashboardTitle()}</div>
            {/* {token && <NavbarProfile />} */}
          </div>
          <div className={Styles.navbar_container}>
            {/* {navList[role]?.map((ele) => (
              <div
                key={ele.url}
                className={`${Styles.navbar_heading} ${
                  isActiveRoute(ele.url) ? Styles.active_nav_item : ""
                }`}
                onClick={() => handleRoute(ele?.url)}
              >
                {ele?.name}
              </div>
            ))} */}
            {token &&
              !(
                role === "MAKER" ||
                role === "CHECKER" ||
                role === "ADMIN" ||
                role === "SUPER_ADMIN"
              ) && <NotificationContainer />}
            {token && <NavProfile />}
          </div>
        </div>
        <div className={Styles.navbar_sub_mobile_container}>
          <div className={Styles.navbar_logo_main_section}>
            <div
              className={Styles.menuContainer}
              onClick={() => setDrawer(true)}
            >
              <MenuIcon />
            </div>
            <div className={Styles.navabr_logo}>
              <Gna />
            </div>
          </div>
          <div className={Styles.currentPageName}>
            {
              navList[role]?.filter(
                (ele) => `/${ele?.url}` === location?.pathname
              )?.[0]?.name
            }
          </div>
          {token && <NavProfile />}
        </div>
      </div>
    </>
  );
};

export default Navbar;
